import Vue from 'vue'
import App from './App.vue'

/* 全局引入element-ui */
import '@/utils/elementUI'
import '@/styles/index.scss'

import router from './router' // 路由
import store from './store' // vuex

/* 全局注册MingTable组件 */
import MingTable from '@/components/MingTable'
Vue.component('MingTable', MingTable)

/* 全局过滤器 */
import * as filters from './filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import '@/permission' // permission control

Vue.config.productionTip = false

store.dispatch('app/getSysteamSetting').then(res => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

